import cx from 'classnames';
import ReactRating from 'react-rating';

import {Icon} from 'components/UIKit/Icon';

import './styles.scss';

type Props = {
    className?: string;
    size?: 'small' | 'medium' | 'large';
    value?: number;
    fractions?: 1 | 2;
    onChange?: (value: number) => void;
}

const Rating = ReactRating as any;

export const StarRating: React.FC<Props> = ({className, value = 0, fractions = 1, size = 'small', onChange}) => (
    <div className={cx(className, 'app-star-rating')}>
        <Rating
            className='react-rating'
            start={0}
            stop={5}
            step={1}
            initialRating={value}
            fractions={fractions}
            emptySymbol={<Icon name='star' className={`star ${size}`} />}
            fullSymbol={<Icon name='star' className={`star ${size} active`} />}
            readonly={!onChange}
            onClick={onChange}
        />
    </div>
);
